// extracted by mini-css-extract-plugin
export var box = "why-choose-module--box--930f0";
export var heading = "why-choose-module--heading--8c040";
export var leftBox = "why-choose-module--leftBox--22a81";
export var networkImg = "why-choose-module--networkImg--90493";
export var overlay = "why-choose-module--overlay--bad37";
export var rightBox = "why-choose-module--rightBox--a331d";
export var textBox = "why-choose-module--textBox--6a4dc";
export var whyChoose = "why-choose-module--whyChoose--b0af3";